<gene-avatar [label]="(userInitials$ | async) ?? ''" [size]="size" />
